import { Component, Input, OnInit } from '@angular/core';
import { Block, BlockAbstractComponent } from '@gallaghercp/core-frontend';
import { TranslatePipe } from '@gallaghercp/core-frontend-contracts';

@Component({
    selector: 'core-bereavement-results',
    templateUrl: './block-bereavement-results.component.html',
    styleUrls: [
        '../../scss/block-leave-of-absence-tool-charts.scss',
        '../../scss/block-leave-of-absence-tool-questions.scss',
        '../../scss/block-leave-of-absence-tool-timeline.scss',
    ],
    imports: [TranslatePipe],
})
export class BlockBereavementResultsComponent extends BlockAbstractComponent implements OnInit {
    @Input() selectedAnswers: Record<string, any> = {};
    @Input() parentBlock: Block | undefined;

    // Section text strings
    introParagraphText!: string;
    lengthOfLeaveText!: string;
    payText!: string;
    processChecklist!: string;
    thingsToConsider!: string;

    override ngOnInit() {
        // Create a mapping of conditions to their corresponding intro paragraph text
        const introParagraphMapping = [
            {
                condition: this.bereavementTier1,
                text: this.parentBlock?.data.introParagraphLeaveQualified,
            },
            {
                condition: this.bereavementTier2,
                text: this.parentBlock?.data.introParagraphLeaveQualified,
            },
            {
                condition: this.bereavementTier3,
                text: this.parentBlock?.data.introParagraphLeaveQualified,
            },
            {
                condition: this.bereavementOther,
                text: this.parentBlock?.data.introParagraphLeaveNotQualified,
            },
        ];

        // Create a mapping of conditions to their corresponding length of leave text
        const lengthOfLeaveMapping = [
            {
                condition: this.bereavementTier1,
                text: this.parentBlock?.data.lengthOfLeaveUpToFiveDays,
            },
            {
                condition: this.bereavementTier2,
                text: this.parentBlock?.data.lengthOfLeaveUpToThreeDays,
            },
            {
                condition: this.bereavementTier3,
                text: this.parentBlock?.data.lengthOfLeaveUpToOneDay,
            },
        ];

        // Create a mapping of conditions to their corresponding pay text
        const payMapping = [
            {
                condition: this.bereavementTier1,
                text: this.parentBlock?.data.payFiveDaysPaidLeave,
            },
            {
                condition: this.bereavementTier2,
                text: this.parentBlock?.data.payThreeDaysPaidLeave,
            },
            {
                condition: this.bereavementTier3,
                text: this.parentBlock?.data.payOneDayPaidLeave,
            },
        ];

        // Create a mapping of conditions to their corresponding process list text
        const processListMapping = [
            {
                condition: this.bereavementTier1,
                text: this.parentBlock?.data.processList,
            },
            {
                condition: this.bereavementTier2,
                text: this.parentBlock?.data.processList,
            },
            {
                condition: this.bereavementTier3,
                text: this.parentBlock?.data.processList,
            },
        ];

        // Create a mapping of conditions to their corresponding things to consider text
        const thingsToConsiderMapping = [
            {
                condition: this.bereavementTier1,
                text: this.parentBlock?.data.thingsToConsiderOne,
            },
            {
                condition: this.bereavementTier2,
                text: this.parentBlock?.data.thingsToConsiderTwo,
            },
            {
                condition: this.bereavementTier3,
                text: this.parentBlock?.data.thingsToConsiderTwo,
            },
        ];

        // Find the first matching condition and set the intro paragraph text
        const introParagraphMatch = introParagraphMapping.find(item => item.condition);
        if (introParagraphMatch) {
            this.introParagraphText = introParagraphMatch.text;
        }

        // Find the first matching condition and set the length of leave text
        const lengthOfLeaveMatch = lengthOfLeaveMapping.find(item => item.condition);
        if (lengthOfLeaveMatch) {
            this.lengthOfLeaveText = lengthOfLeaveMatch.text;
        }

        // Find the first matching condition and set the pay text
        const payMatch = payMapping.find(item => item.condition);
        if (payMatch) {
            this.payText = payMatch.text;
        }

        // Find the first matching condition and set the process list text
        const processListMatch = processListMapping.find(item => item.condition);
        if (processListMatch) {
            this.processChecklist = processListMatch.text;
        }

        // Find the first matching condition and set the things to consider text
        const thingsToConsiderMatch = thingsToConsiderMapping.find(item => item.condition);
        if (thingsToConsiderMatch) {
            this.thingsToConsider = thingsToConsiderMatch.text;
        }
        super.ngOnInit();
    }

    get bereavementTier1(): boolean {
        return this.selectedAnswers['whoHasPassedAway'] == 'tier1';
    }

    get bereavementTier2(): boolean {
        return this.selectedAnswers['whoHasPassedAway'] == 'tier2';
    }

    get bereavementTier3(): boolean {
        return this.selectedAnswers['whoHasPassedAway'] == 'tier3';
    }

    get bereavementOther(): boolean {
        return this.selectedAnswers['whoHasPassedAway'] == 'other';
    }
}
